import Home from "./pages/home";
import { Fragment } from "react";

function App() {
  return (
    <Fragment>
      <Home />
    </Fragment>
  );
}

export default App;
